export const ASSIGN_SELECT_PLACEHOLDER = 'Choose reference template';
export const ASSIGN_REFERENCE_TEMPLATE = 'Assign reference template';
